const PREFIX = '@@AUTH';

export const SET_USER = `${PREFIX}/SET_USER`;
export const START_LOADING = `${PREFIX}/START_LOADING`;
export const END_LOADING = `${PREFIX}/END_LOADING`;
